/* Public GeoNames index; searches never leave the browser. */
(() => {
  'use strict';
  let pending;
  const fold = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  async function load(url) {
    if (!pending) pending = fetch(url, {credentials:'omit', referrerPolicy:'no-referrer'})
      .then(response => { if (!response.ok) throw Error('cities'); return response.json(); })
      .then(data => {
        if (data.version !== 1 || !Array.isArray(data.cities) || !Array.isArray(data.zones)) throw Error('cities');
        return data.cities.map(row => {
          const [id,name,ascii,region,country,latitude,longitude,zone] = row;
          const label = [name,data.regions[region],data.countries[country]].filter(Boolean).join(', ');
          return {id,name,label,latitude,longitude,zone:data.zones[zone],search:fold(`${label} ${ascii}`),start:fold(name)};
        });
      }).catch(() => { pending = null; throw Error('cities'); });
    return pending;
  }
  function search(cities, query) {
    const words = fold(query).split(/\s+/).filter(Boolean);
    if (words.join('').length < 2) return [];
    return cities.filter(city => words.every(word => city.search.includes(word)))
      .sort((a,b) => Number(b.start.startsWith(words[0])) - Number(a.start.startsWith(words[0])))
      .slice(0,8);
  }
  window.MoonmeetChartCities = Object.freeze({load,search});
})();
